import { Card, Group, Text, useMantineColorScheme } from "@mantine/core";
import { useTranslation } from 'react-i18next';
import PropTypes from "prop-types";

const HelpCardAccordion = ({ componentTitle, componentSubtitle, details, id }) => {
  const { colorScheme } = useMantineColorScheme();
  const { t } = useTranslation();
  return (
    <Card card-id={id} shadow="sm" padding="lg" withBorder style={styles.card}>
      <Card.Section
        withBorder
        inheritPadding
        py="xs"
        className={`sidebar-content ${
          colorScheme === "dark" ? "dark-mode" : "light-mode"
        }`}
      >
        <Group position="apart" style={{ justifyContent: "flex-start" }}>
          <Text size={"lg"} order={4}>
            {componentTitle || t('help.componentTitle')}
          </Text>
        </Group>
      </Card.Section>
      {componentSubtitle && (
        <Card.Section withBorder inheritPadding py="xs" className={`sidebar-content ${
          colorScheme === "dark" ? "dark-mode" : "light-mode"
        }`}>
          <Group position="apart" style={{ justifyContent: "flex-start" }}>
            <Text order={4}>{componentSubtitle}</Text>
          </Group>
        </Card.Section>
      )}
      {details && (
        <Card.Section withBorder inheritPadding py="xs" className={`sidebar-content ${
          colorScheme === "dark" ? "dark-mode" : "light-mode"
        }`}>
          <Text style={styles.label} component="div">
            {/* Render details as rich text, supporting \n and basic HTML */}
            <span
              dangerouslySetInnerHTML={{
                __html: (details || "")
                  .replace(/\n/g, "<br />")
              }}
            />
          </Text>
        </Card.Section>
      )}
    </Card>
  );
};

const styles = {
  card: {
    maxWidth: "400px",
    margin: "20px auto",
  },
  label: {
    margin: "10px 0",
  },
};

HelpCardAccordion.propTypes = {
  componentTitle: PropTypes.string,
  componentSubtitle: PropTypes.string,
  details: PropTypes.string,
  id: PropTypes.string,
};

export default HelpCardAccordion;